import AppConstants from "../appConstants";
import jwt_decode from "jwt-decode";
import store from '../store/store';
import biometryHelper from "./biometry-helper";
import checkDeviceTypeHelper from "./check-device-type-helper";

class LocalStorageHelper {

  saveData(key, value) {
    window.localStorage.setItem(key, value);
  }

  clear() {
    window.localStorage.clear();
  }

  removeItem(key) {
    window.localStorage.removeItem(key);
  }

  updateToken(token) {
    const currentUser = this.getCurrentUser();
    currentUser.token = token;
    this.setCurrentUser(currentUser);
  }

  clearAcceptorToken() {
    console.log('[clearAcceptorToken] clear token in localstorage')
    const currentUser = this.getCurrentUser();
    currentUser.acptoken = '';
    currentUser.refresh_token = '';
    currentUser.acpurl = '';
    currentUser.domain = '';
    this.setCurrentUser(currentUser);
  }
  updateAcceptorData(data) {
    const currentUser = this.getCurrentUser();
    if (data.token) currentUser.acptoken = data.token;
    if (data.url) currentUser.acpurl = data.url;
    if (data.domain) currentUser.domain = data.domain;
    if (data.refresh_token) currentUser.refresh_token = data.refresh_token;
    this.setCurrentUser(currentUser);
  }
  updateAcceptorToken(token) {
    const currentUser = this.getCurrentUser();
    currentUser.acptoken = token;
    this.setCurrentUser(currentUser);
  }
  updateAcceptorRefreshToken(refresh_token) {
    const currentUser = this.getCurrentUser();
    currentUser.refresh_token = refresh_token;
    this.setCurrentUser(currentUser);
  }

  updateWDMAInfo(data) {
    const currentUser = this.getCurrentUser();
    currentUser.sessionId = data.sessionId;
    currentUser.wdmasid = data.wdmasid;
    this.setCurrentUser(currentUser);
  }

  updateLocale(locale) {
    console.log('[updateLocale]', locale);
    this.saveData(AppConstants.LOCAL_STORAGE_LOCALE, locale);
    if (!store.state.isDesktop && checkDeviceTypeHelper.isNativeApp() && checkDeviceTypeHelper.isReactApp()) {
      biometryHelper.setLanguage();
    }
  }

  updateReportViewStyle(viewStyle) {
    const currentUser = this.getCurrentUser();
    currentUser.Viewstyle = viewStyle;
    this.setCurrentUser(currentUser);
    this.saveData(AppConstants.LOCAL_STORAGE_REPORT_VIEW_STYLE, viewStyle);
    store.dispatch('reportListStyle', viewStyle);

  }

  setSidebarMainMenu(reduce) {
    this.saveData(AppConstants.LOCAL_STORAGE_MAIN_MENU_SIDEBAR_REDUCE, reduce);
  }

  setSidebarInformative(reduce) {
    this.saveData(AppConstants.LOCAL_STORAGE_INFORMATIVE_SIDEBAR_REDUCE, reduce);
  }

  setCurrentUser(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_CURRENT_USER, JSON.stringify(data));
    store.dispatch('updateUserInfo', data);
  }

  setCurrentBrowserSession(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_SESSION_BROWSER, data);
  }

  getUserHasLoggedIn() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_HAS_LOGGED_IN);
  }

  getCurrentUser() {
    try {
      return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER)) || {};
    } catch (e) {
      return {};
    }
  }

  getReportViewStyle() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_REPORT_VIEW_STYLE));
  }

  getTheme() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_THEME);
  }

  getViewImportantTickers() {
    const currentUser = this.getCurrentUser();
    let viewImportantTicker = currentUser.viewImportantTickers;
    return viewImportantTicker;
  }

  getViewHighlightsTickers() {
    const currentUser = this.getCurrentUser();
    let viewHighlightsTickers = currentUser.viewHighlightsTickers;
    return viewHighlightsTickers;
  }

  getFormatAlignDetail() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_FORMAT_ALIGN_DETAIL);
  }

  getLocale() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_LOCALE) || 'PtBr';
  }

  getLocaleLocalStorage() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_LOCALE);
  }

  // getCountryCode() {
  //   // Default is ptBr
  //   const defaultCountry = 1;
  //   try {
  //     const curUser = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));
  //     return jwt_decode(curUser.token).country;
  //   } catch (e) {
  //     return defaultCountry;
  //   }
  // }

  getWdmaRoute() {
    // Default is ptBr
    const defaultCountry = 1;
    try {
      const curUser = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));
      return jwt_decode(curUser.token).wdma_route;
    } catch (e) {
      return defaultCountry;
    }
  }

  getSidebarMainMenuReduce() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_MAIN_MENU_SIDEBAR_REDUCE) == "true";
  }

  getS4Login() {
    const user = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));
    if (!user || !user.s4Login) {
      return false;
    }

    return user.s4Login;
  }

  getSidebarInformativeReduce() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_INFORMATIVE_SIDEBAR_REDUCE) == "true";
  }

  getMetadata() {
    try {
      const user = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));
      if (user.metadata && user.metadata.data) {
        return user.metadata.data;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  updateMetadata(metadata) {
    const currentUser = this.getCurrentUser();
    currentUser.metadata = metadata;
    this.setCurrentUser(currentUser);
  }

  updateUserRights(rights) {
    const currentUser = this.getCurrentUser();
    currentUser.rights = rights;
    this.setCurrentUser(currentUser);
  }

  getUserLayoutPrefs() {
    // Default prefs
    let prefs = {
      theme: "light",
      viewstyle: AppConstants.REPORT_VIEW_STYLE.CARDVIEW,
      favoriteContent: [],
      skipTour: false,
      rateTextSpeech: 1.0
    }

    try {
      const user = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));

      if (user.theme) {
        prefs.theme = user.theme;
      }

      if (user.viewstyle) {
        if (user.viewstyle === "1") {
          prefs.viewstyle = AppConstants.REPORT_VIEW_STYLE.LISTVIEW;
        } else if (user.viewstyle === "2") {
          prefs.viewstyle = AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED;
        } else {
          prefs.viewstyle = AppConstants.REPORT_VIEW_STYLE.CARDVIEW;
        }
      }

      if (user.favoriteContent) {
        prefs.favoriteContent = user.favoriteContent;
      }

      if (user.rateTextSpeech) {
        prefs.rateTextSpeech = user.rateTextSpeech;
      }

      prefs.skipTour = user.skipTour || false;

      return prefs;
    } catch (e) {
      return prefs;
    }
  }

  getFavoriteMenuContent() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_FAVORITE_CONTENT)) || [];
  }

  updateFavoriteMenuContent(contentList) {
    const currentUser = this.getCurrentUser();
    currentUser.favoriteContent = contentList;
    this.setCurrentUser(currentUser);
    window.localStorage.setItem(AppConstants.LOCAL_STORAGE_FAVORITE_CONTENT, JSON.stringify(contentList));
  }

  checkExisteSessioninBrowser() {
    if (this.getCurrentBrowserSession() == 'true') {
      // alert('exist session in this browser');
      if (this.getUserHasLoggedIn() === 'true') {
        this.updateLogoutOldSession(true);
      }
    } else {
      this.updateLogoutOldSession(false);
    }

    this.setCurrentBrowserSession(true);
  }

  getLogoutOldSession() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_EVENT_CLOSE_SESSION);
  }
  updateLogoutOldSession(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_EVENT_CLOSE_SESSION, data);
  }

  getQuotesPageDetach() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_EVENT_QUOTES_PAGE_DETACH) || false;
  }
  updateQuotesPageDetach(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_EVENT_QUOTES_PAGE_DETACH, data);
  }

  getUserSkipTour() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_USER_SKIP_TOUR) || false;
  }
  updateUserSkipTour(data) {
    const currentUser = this.getCurrentUser();
    currentUser.skipTour = data;
    this.setCurrentUser(currentUser);
    this.saveData(AppConstants.LOCAL_STORAGE_USER_SKIP_TOUR, data);
  }

  getUserAfterLoginShowBiometry() {
    const item = window.localStorage.getItem(AppConstants.LOCAL_STORAGE_USER_AFTER_LOGIN_SHOW_BIOMETRY);
    return item === "undefined" || item === undefined || item === null;
  }
  updateUserAfterLoginShowBiometry(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_USER_AFTER_LOGIN_SHOW_BIOMETRY, data);
  }

  updateRateTextSpeech(data) {
    const currentUser = this.getCurrentUser();
    currentUser.rateTextSpeech = data;
    this.setCurrentUser(currentUser);
    store.dispatch('updateRateTextSpeech', data);
  }
  updateZoom(data) {
    const currentUser = this.getCurrentUser();
    currentUser.zoom = data;
    this.setCurrentUser(currentUser);
    store.dispatch('updateZoom', data);
    this.saveData(AppConstants.LOCAL_STORAGE_ZOOM, data);
  }
  updateZoomDetail(data) {
    const currentUser = this.getCurrentUser();
    currentUser.zoomDetail = data;
    this.setCurrentUser(currentUser);
    store.dispatch('updateZoomDetail', data);
  }
  updateFormatAlignDetail(data) {
    const currentUser = this.getCurrentUser();
    currentUser.formatAlignDetail = data;
    this.setCurrentUser(currentUser);
    this.saveData(AppConstants.LOCAL_STORAGE_FORMAT_ALIGN_DETAIL, data);
    store.dispatch('updateFormatAlignDetail', data);
  }
  updateTheme(theme) {
    const currentUser = this.getCurrentUser();
    currentUser.theme = theme;
    this.setCurrentUser(currentUser);
    this.saveData(AppConstants.LOCAL_STORAGE_THEME, theme);
    store.dispatch('updateTheme', theme);
  }
  updateViewImportantTickers(val) {
    const currentUser = this.getCurrentUser();
    currentUser.viewImportantTickers = val;
    this.setCurrentUser(currentUser);
    store.dispatch('viewImportantTickers', val);
  }
  updateViewHighlightsTickers(val) {
    const currentUser = this.getCurrentUser();
    currentUser.viewHighlightsTickers = val;
    this.setCurrentUser(currentUser);
    store.dispatch('viewHighlightsTickers', val);
  }
  updateBiometry(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_BIOMETRY, data);
    store.dispatch('updateBiometry', data);
  }

  updateBiometrySecrets(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_BIOMETRY_SECRETS, data);
  }
  updateBiometrySecretsStatus(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_BIOMETRY_SECRETS_STATUS, data);
  }
  updateBiometryType(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_BIOMETRY_TYPE, data);
  }
  updateIsBiometryAvailable(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_IS_BIOMETRY_AVAILABLE, data);
  }
  updateHasBiometry(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_HAS_BIOMETRY, data);
  }

  getBiometrySecrets() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_BIOMETRY_SECRETS);
  }
  getBiometrySecretsStatus() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_BIOMETRY_SECRETS_STATUS);
  }
  getBiometryType() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_BIOMETRY_TYPE);
  }
  getIsBiometryAvailable() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_IS_BIOMETRY_AVAILABLE);
  }
  getHasBiometry() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_HAS_BIOMETRY);
  }
  getBiometry() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_BIOMETRY);
  }

  updateUserProfile(profile) {
    const currentUser = this.getCurrentUser();
    currentUser.profile = profile;
    this.setCurrentUser(currentUser);
  }
  updateUserData(user) {
    const currentUser = this.getCurrentUser();
    if (user.profile) {
      currentUser.profile = user.profile;
    }
    if (user.signature) {
      currentUser.signature = user.signature;
    }
    if (user.hasQuotesRights) {
      currentUser.hasQuotesRights = user.hasQuotesRights;
    }
    if (user.requestIp) currentUser.requestIp = user.requestIp;
    if (user.userAgent) currentUser.userAgent = user.userAgent;
    if (user.operatingSystem) currentUser.operatingSystem = user.operatingSystem;
    if (user.browser) currentUser.browser = user.browser;
    
    this.setCurrentUser(currentUser);
  }

  getCurrentFilter() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_FILTER)) || [];
  }

  updateCurrentFilter(filter) {
    window.localStorage.setItem(AppConstants.LOCAL_STORAGE_CURRENT_FILTER, JSON.stringify(filter));
  }

  updateEventOnLogin(val) {
    window.localStorage.setItem(AppConstants.LOCAL_STORAGE_EVENT_ON_LOGIN, val);
  }

  getEventOnLogin() {
    try {
      return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_EVENT_ON_LOGIN));
    } catch (error) {
      return false;
    }
  }

  getLogoutOnReloadPage() {
    return JSON.parse(window.localStorage.getItem('canLogoutOnReloadPage') || true);
  }
  setLogoutOnReloadPage(val) {
    return window.localStorage.setItem('canLogoutOnReloadPage', val);
  }
  setCookiesAccepted() {
    return window.localStorage.setItem(AppConstants.LOCAL_STORAGE_COOKIES_ACCEPTED, "true");
  }
  setCookiesRejected() {
    return window.localStorage.setItem(AppConstants.LOCAL_STORAGE_COOKIES_REJECTED, "true");
  }

  getCookieAccepted() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_COOKIES_ACCEPTED);
  }

  getCookieRejected() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_COOKIES_REJECTED);
  }

  getScheduleData() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_SCHEDULE_DATA)) || [];
  }

  updateScheduleData(val) {
    this.saveData(AppConstants.LOCAL_STORAGE_SCHEDULE_DATA, val);
    store.dispatch('setScheduleData', val);
  }
  setScheduleData(val) {
    this.saveData(AppConstants.LOCAL_STORAGE_SCHEDULE_DATA, val);
    store.dispatch('setScheduleData', val);
  }

  updateHighlightCollapsed(val) {
    const currentUser = this.getCurrentUser();
    currentUser.highlightCollapsed = val;
    this.setCurrentUser(currentUser);
    this.saveData(AppConstants.LOCAL_STORAGE_HIGHLIGHT_COLLAPSED, val);
    store.dispatch('updateHighlightCollapsed', val);
  }

  getOneSignalID() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_ONESIGNAL_ID);
  }
  setOneSignalID(val) {
    this.saveData(AppConstants.LOCAL_STORAGE_ONESIGNAL_ID, val);
  }
}

export default new LocalStorageHelper();
